import groundcover from '@groundcover/browser';

if (process.env.REACT_APP_NODE_ENV && process.env.REACT_APP_GROUNDCOVER_ENDPOINT && process.env.REACT_APP_GROUNDCOVER_API_KEY) {
	groundcover.init({
		apiKey: process.env.REACT_APP_GROUNDCOVER_API_KEY,
		dsn: `https://${process.env.REACT_APP_GROUNDCOVER_ENDPOINT}`,
		cluster: `greenroom-${process.env.REACT_APP_NODE_ENV}`,
		environment: process.env.REACT_APP_NODE_ENV,
		appId: 'greenroom-browser',
		options: { debug: process.env.REACT_APP_GROUNDCOVER_DEBUG === 'true' },
	});
}
